import { StorageService, actions } from "./storage.service";
import { Uris } from "../../routes/services/Uris";
import { Injectable } from "@angular/core";
import { webSocket } from "rxjs/webSocket";

@Injectable({
  providedIn: "root"
})
export class SocketService {
  conectionSocket;
  constructor(public storageService: StorageService) {}

  /** Ultimo lote de acciones enviado al socket, para poder reenviarlo si la conexion se cae. */
  actions: Array<actions> = [];

  /**
   * Resuelve el token con el que se autentica la conexion del socket: el del
   * cliente suplantado cuando el admin esta en "modo cliente", o el del
   * usuario que inicio sesion en cualquier otro caso.
   * @returns Token a usar en el handshake del socket.
   */
  validateToken() {
    const { client, mode } = this.storageService.localValue;
    let tokenUser = localStorage.getItem("token");

    if (mode === 1 && client) {
      return client.token;
    }
    if (!mode) {
      return tokenUser;
    }
  }

  /**
   * Envia un nuevo lote de acciones al socket ya conectado. Antes de mandarlas,
   * da de baja los listeners de granja del lote anterior que ya no aplican
   * (comparando por `data.farm`), para no seguir escuchando granjas de las
   * que ya no se necesita informacion.
   * @param actions - Acciones a registrar (listen.all, whitelist.set, gateways.add_listener...).
   * @returns void
   */
  socketNext = async (actions: Array<actions>) => {
    const remove_listener: Array<actions> = [...this.actions].filter((item) => {
      return !actions.some((action) => action.data?.farm === item.data?.farm);
    });
    const mode = this.storageService.localValue.mode;

    if (remove_listener.length > 0 && (mode || !this.storageService.validateSoloAdmin())) {
      const next = remove_listener.map((item) => {
        return { ...item, type: "gateways.remove_listener" };
      });
      next.forEach(async (action) => {
        await this.conectionSocket.next(action);
      });
    }
    actions.forEach(async (action) => {
      await this.conectionSocket.next(action);
    });

    this.actions = [...actions];
  };

  /**
   * Cierra la suscripcion actual del socket, si existe. No limpia `actions`,
   * para poder reabrir la misma conexion con el mismo lote via `connectSocket`.
   * @returns void
   */
  unSuscribeSocket() {
    if (this.conectionSocket) {
      this.conectionSocket.unsubscribe();
    }
  }

  /**
   * Abre (o reabre) la conexion websocket y empieza a escuchar mensajes,
   * publicandolos en `StorageService.storageObs.socket` para que cualquier
   * componente suscrito los reciba via `watchStorage("socket")`. Ante un error
   * de conexion, reintenta automaticamente pasado 1 segundo con el mismo lote
   * de acciones.
   * @param actions - Acciones iniciales a registrar al conectar (normalmente `gateways.add_listener` por granja).
   * @returns void
   */
  connectSocket = async (actions) => {
    this.unSuscribeSocket();
    this.conectionSocket = webSocket({
      url: Uris.SOCKET
    });

    this.conectionSocket.subscribe({
      next: (msg: any) => {
        this.storageService.setItem("socket", msg);
        console.log(msg);
      },
      error: (err) => {
        this.conectionSocket.unsubscribe();
        setTimeout(() => this.connectSocket(this.actions), 1000);
      },
      complete: () => {}
    });
    this.actions = [...actions];
    this.conectionSocket.next({
      token: this.validateToken(),
      actions
    });
  };

  /**
   * Restringe el socket a escuchar solo las MACs indicadas. Se usa cuando la
   * suscripcion por granja del login no alcanza a cubrir los alimentadores de
   * interes (por ejemplo, un admin operando sobre estanques de varias granjas
   * a la vez), como en `alerts.component.ts` o en el envio de raciones de
   * `SendRationComponent`.
   * @param feeders - Alimentadores cuyas MACs se quieren escuchar.
   * @returns void
   */
  setFeedersSocket = (feeders) => {
    this.socketNext([
      {
        type: "listen.all"
      },
      {
        type: "whitelist.set",
        data: {
          addresses: feeders.map((item) => item.mac)
        }
      }
    ]);
  };
}
